import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <Link to="/register" className="back-link">← {t('common.back')}</Link>
      
      <div className="legal-header">
        <img src="/images/ai-logo.png" alt="SmartGain Community" className="legal-logo" />
        <h1>{t('legal.terms.title')}</h1>
        <p className="legal-meta">{t('legal.terms.last_updated')}: 01/04/2026</p>
      </div>

      <div className="legal-content">
        <div className="legal-section">
          <p>{t('legal.terms.intro')}</p>
        </div>

        <div className="legal-section">
          <h2>1. {t('legal.terms.parties_title')}</h2>
          <p>{t('legal.terms.parties_text')}</p>
        </div>

        <div className="legal-section">
          <h2>2. {t('legal.terms.acceptance_title')}</h2>
          <p>{t('legal.terms.acceptance_text')}</p>
        </div>

        <div className="legal-section">
          <h2>3. {t('legal.terms.service_description_title')}</h2>
          <p>{t('legal.terms.service_description_text')}</p>
          <ul>
            <li>{t('legal.terms.service_feature_1')}</li>
            <li>{t('legal.terms.service_feature_2')}</li>
            <li>{t('legal.terms.service_feature_3')}</li>
            <li>{t('legal.terms.service_feature_4')}</li>
            <li>{t('legal.terms.service_feature_5')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. {t('legal.terms.account_title')}</h2>
          <p>{t('legal.terms.account_text')}</p>
        </div>

        <div className="legal-section">
          <h2>5. {t('legal.terms.usage_title')}</h2>
          <p>{t('legal.terms.usage_text')}</p>
          <ul>
            <li>{t('legal.terms.usage_rule_1')}</li>
            <li>{t('legal.terms.usage_rule_2')}</li>
            <li>{t('legal.terms.usage_rule_3')}</li>
            <li>{t('legal.terms.usage_rule_4')}</li>
            <li>{t('legal.terms.usage_rule_5')}</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>6. {t('legal.terms.intellectual_property_title')}</h2>
          <p>{t('legal.terms.intellectual_property_text')}</p>
        </div>

        <div className="legal-section">
          <h2>7. {t('legal.terms.ai_content_title')}</h2>
          <p>{t('legal.terms.ai_content_text')}</p>
        </div>

        <div className="legal-section">
          <h2>8. {t('legal.terms.third_party_title')}</h2>
          <p>{t('legal.terms.third_party_text')}</p>
        </div>

        <div className="legal-section">
          <h2>9. {t('legal.terms.withdrawal_title')}</h2>
          <p>{t('legal.terms.withdrawal_text')}</p>
        </div>

        <div className="legal-section">
          <h2>10. {t('legal.terms.limitation_title')}</h2>
          <p>{t('legal.terms.limitation_text')}</p>
        </div>

        <div className="legal-section">
          <h2>11. {t('legal.terms.termination_title')}</h2>
          <p>{t('legal.terms.termination_text')}</p>
        </div>

        <div className="legal-section">
          <h2>12. {t('legal.terms.changes_title')}</h2>
          <p>{t('legal.terms.changes_text')}</p>
        </div>

        <div className="legal-section">
          <h2>13. {t('legal.terms.governing_law_title')}</h2>
          <p>{t('legal.terms.governing_law_text')}</p>
        </div>

        <div className="legal-section">
          <h2>14. {t('legal.terms.dispute_title')}</h2>
          <p>{t('legal.terms.dispute_text')}</p>
        </div>

        <div className="legal-section">
          <h2>15. {t('legal.terms.contact_title')}</h2>
          <p>{t('legal.terms.contact_text')}</p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
